import React from 'react';
import ButtonComponent from '../../library/components/button.component';
import EmailSentIcon from '../../library/icons/email-sent-icon';

const MagicLinkSentComponent = () => {
    return (
        <div className="linkcontent">
            <div className="img email">
                <EmailSentIcon />
            </div>
            <h2>Thanks for renewing your share link</h2>
            <p>An email is on the way!</p>
            <span>If you don't receive and email within 1-5 minutes, please contact your account manager for assistance.</span>
        </div>
    );
};

export default MagicLinkSentComponent;
